import { useEffect, useLayoutEffect } from 'react'
import useDidUpdate from '../useDidUpdate'
import { createDeepCompareEffect } from './createDeepCompareEffect'

export const useDeepCompareEffect = createDeepCompareEffect(useEffect)
export const useDeepCompareLayoutEffect =
  createDeepCompareEffect(useLayoutEffect)
export const useDeepCompareDidUpdate = createDeepCompareEffect(useDidUpdate)
